<mat-card appearance="raised" class="tds-u-pl2 tds-u-pt1 tds-u-mb1">
  <mat-card-title>
    {{ item.senha }}
  </mat-card-title>

  <mat-card-content>
    <mat-chip-set>
      @if (item.critico) {
        <mat-chip>CRÍTICO</mat-chip>
      }
      @if (item.milkrun) {
        <mat-chip>MILKRUN</mat-chip>
      }
    </mat-chip-set>
  </mat-card-content>
</mat-card>
